// Airline name -> IATA code, and per-route airline coverage.
// Source: OpenFlights open data (openflights.org, public domain), filtered to
// active airlines with a real 2-character IATA code, bundled statically so
// there is no runtime API call, key, or rate limit.
export const AIRLINE_CODES = {
  "1Time Airline": "1T",
  "40-Mile Air": "Q5",
  "Abacus International": "1B",
  "ABSA - Aerolinhas Brasileiras": "M3",
  "Abu Dhabi Amiri Flight": "MO",
  "Access Air": "ZA",
  "Ada Air": "ZY",
  "Adam Air": "KI",
  "Adria Airways": "JP",
  "Aegean Airlines": "A3",
  "Aer Arann": "RE",
  "Aer Lingus": "EI",
  "Aereonautica militare": "JY",
  "Aero Benin": "EM",
  "Aero Condor Peru": "Q6",
  "Aero Contractors": "AJ",
  "Aero Flight": "GV",
  "Aero Lanka": "QL",
  "Aero VIP": "2D",
  "Aero-Service": "BF",
  "Aerocondor": "2B",
  "Aeroflot Russian Airlines": "SU",
  "Aeroflot-Don": "D9",
  "Aeroflot-Nord": "5N",
  "Aerolane": "XL",
  "Aeroline GmbH": "7E",
  "Aerolineas Argentinas": "AR",
  "Aerolineas Galapagos": "2K",
  "Aerolitoral": "5D",
  "Aeromar": "VW",
  "AeroMéxico": "AM",
  "Aeropelican Air Services": "OT",
  "Aeroper": "PL",
  "AeroRep": "P5",
  "Aerosur": "5L",
  "Aerosvit Airlines": "VV",
  "AeroWorld": "W4",
  "Africa West": "FK",
  "Afriqiyah Airways": "8U",
  "Aigle Azur": "ZI",
  "Air Afrique": "RK",
  "Air Algerie": "AH",
  "Air Alps Aviation": "A6",
  "Air Antilles Express": "3S",
  "Air Arabia": "G9",
  "Air Arabia Egypt": "E5",
  "Air Arabia Maroc": "3O",
  "Air Astana": "KC",
  "Air Austral": "UU",
  "Air Bagan": "W9",
  "Air Baltic": "BT",
  "Air Bangladesh": "B9",
  "Air Berlin": "AB",
  "Air Bosna": "JA",
  "Air Botswana": "BP",
  "Air Bourbon": "ZB",
  "Air Burkina": "2J",
  "Air Busan": "BX",
  "Air Caledonie International": "SB",
  "Air Canada": "AC",
  "Air Canada Jazz": "QK",
  "Air Caraïbes": "TX",
  "Air Cargo Carriers": "2Q",
  "Air Cargo Germany": "6U",
  "Air Carnival": "2S",
  "Air Chathams": "CV",
  "Air China": "CA",
  "Air Choice One": "3E",
  "Air Comet Chile": "3I",
  "Air Costa": "LB",
  "Air Dolomiti": "EN",
  "Air Europa": "UX",
  "Air Europe": "PE",
  "Air Exel": "XT",
  "Air Finland": "OF",
  "Air Florida": "QH",
  "Air Foyle": "GS",
  "Air France": "AF",
  "Air Glaciers": "7T",
  "Air Greenland": "GL",
  "Air Guinee Express": "2U",
  "Air Guyane": "GG",
  "Air Hamburg": "HH",
  "Air Iceland": "NY",
  "Air India Express": "IX",
  "Air India Limited": "AI",
  "Air India Regional": "CD",
  "Air Indus": "PP",
  "Air Ivoire": "VU",
  "Air Jamaica": "JM",
  "Air Japan": "NQ",
  "Air Kazakhstan": "9Y",
  "Air Kenya": "QP",
  "Air Kiribati": "4A",
  "Air Koryo": "JS",
  "Air Libert": "VD",
  "Air Lituanica": "LT",
  "Air Luxor": "LK",
  "Air Macau": "NX",
  "Air Madagascar": "MD",
  "Air Madrid": "NM",
  "Air Malawi": "QM",
  "Air Malta": "KM",
  "Air Mandalay": "6T",
  "Air Marshall Islands": "CW",
  "Air Mauritius": "MK",
  "Air Mediterranee": "DR",
  "Air Mekong": "P8",
  "Air Moldova": "9U",
  "Air Mozambique": "TM",
  "Air Namibia": "SW",
  "Air New Zealand": "NZ",
  "Air Nippon": "EL",
  "Air Niugini": "PX",
  "Air North Charter - Canada": "4N",
  "Air Nostrum": "YW",
  "Air One": "AP",
  "Air Pacific": "FJ",
  "Air Pegasus": "OP",
  "Air Philippines": "2P",
  "Air Plus Comet": "A7",
  "Air Rarotonga": "GZ",
  "Air Sahara": "S2",
  "Air Saint Pierre": "PJ",
  "Air Salone": "2O",
  "Air Serbia": "JU",
  "Air Seychelles": "HM",
  "Air Sicilia": "BM",
  "Air Sinai": "4D",
  "Air Tahiti": "VT",
  "Air Tahiti Nui": "TN",
  "Air Tanzania": "TC",
  "Air Tindi": "8T",
  "Air Transat": "TS",
  "Air Vanuatu": "NF",
  "Air VIA": "VL",
  "Air Vistara": "UK",
  "Air Volga": "G6",
  "Air Wales": "6G",
  "Air Wisconsin": "ZW",
  "Air Zimbabwe": "UM",
  "Air2there": "F8",
  "AirAsia": "AK",
  "AirAsia X": "D7",
  "Airblue": "ED",
  "Aircompany Yakutia": "R3",
  "Aires": "4C",
  "Airlinair": "A5",
  "Airlines Of Tasmania": "FO",
  "Airlines PNG": "CG",
  "Airlink": "4Z",
  "Airnorth": "TL",
  "AirOnix": "OG",
  "AirRussia": "R8",
  "AirTran Airways": "FL",
  "Al-Naser Airlines": "NA",
  "ALAK": "J4",
  "Alaska Airlines": "AS",
  "Alaska Central Express": "KO",
  "Alaska Seaplane Service": "J5",
  "Albanian Airlines": "LV",
  "Alitalia": "AZ",
  "Alitalia Cityliner": "CT",
  "Alitalia Express": "XM",
  "All Africa": "9A",
  "All America": "A2",
  "All America AR": "2R",
  "All America BOPY": "0P",
  "All America BR": "1Y",
  "All America CL": "1R",
  "All America CO": "0Y",
  "All America MX": "0M",
  "All America US": "AG",
  "All Argentina": "L1",
  "All Argentina Express": "Z0",
  "All Asia": "L9",
  "All Colombia": "7O",
  "All Europe": "N9",
  "All Nippon Airways": "NH",
  "All Spain": "N7",
  "Allegiant Air": "G4",
  "Alliance Airlines": "QQ",
  "AlMasria Universal Airlines": "UJ",
  "Aloha Airlines": "AQ",
  "Alrosa Mirny Air Enterprise": "6R",
  "Amaszonas": "Z8",
  "America West Airlines": "HP",
  "American Airlines": "AA",
  "American Eagle Airlines": "MQ",
  "Amsterdam Airlines": "WD",
  "Ansett Australia": "AN",
  "Apache Air": "ZM",
  "Ariana Afghan Airlines": "FG",
  "Arik Niger": "Q9",
  "Arkefly": "OR",
  "Arkia Israel Airlines": "IZ",
  "Armavia": "U8",
  "Arrow Air": "JW",
  "Aserca Airlines": "R7",
  "Asia Wings": "Y5",
  "Asian Spirit": "6K",
  "Asian Wings Airways": "AW",
  "Asiana Airlines": "OZ",
  "Askari Aviation": "4K",
  "Astair": "8D",
  "Astraeus": "5W",
  "Astrakhan Airlines": "OB",
  "Astral Aviation": "8V",
  "ATA Airlines": "I3",
  "Athens Airways": "ZF",
  "Atifly": "A1",
  "Atlant-Soyuz Airlines": "3G",
  "Atlantic Airways": "RC",
  "Atlantic Southeast Airlines": "EV",
  "Atlantis European Airways": "TD",
  "Atlas Air": "5Y",
  "Atlas Blue": "8A",
  "Atlasjet": "KK",
  "ATRAN Cargo Airlines": "V8",
  "Augsburg Airways": "IQ",
  "Aurigny Air Services": "GR",
  "Austral Brasil": "W7",
  "Austral Lineas Aereas": "AU",
  "Austrian Airlines": "OS",
  "Aviabus": "U1",
  "Avialeasing Aviation Company": "EC",
  "Avianca - Aerovias Nacionales de Colombia": "AV",
  "Avianova": "AO",
  "Avient Aviation": "Z3",
  "Avies": "U3",
  "Aws express": "B0",
  "Azerbaijan Airlines": "J2",
  "Azul": "AD",
  "BA CityFlyer": "CJ",
  "Bahamasair": "UP",
  "Baikotovitchestrian Airlines": "BU",
  "Balkan Bulgarian Airlines": "LZ",
  "Baltic Air lines": "B1",
  "Bangkok Airways": "PG",
  "Barents AirLink": "8N",
  "Bassaka airlines": "5B",
  "Bearskin Lake Air Service": "JV",
  "Belair Airlines": "4T",
  "Belavia Belarusian Airlines": "B2",
  "Bellview Airlines": "B3",
  "Bemidji Airlines": "CH",
  "Bering Air": "8E",
  "Berjaya Air": "J8",
  "Biman Bangladesh Airlines": "BG",
  "Binter Canarias": "NT",
  "Black Stallion Airways": "BZ",
  "Blue Air": "0B",
  "Blue Panorama Airlines": "BV",
  "Blue Wings": "QW",
  "Blue1": "KF",
  "bmi": "BD",
  "bmibaby": "WW",
  "Boutique Air": "4B",
  "BQB Lineas Aereas": "5Q",
  "BRAZIL AIR": "GB",
  "Brit Air": "DB",
  "British Airways": "BA",
  "British International Helicopters": "BS",
  "British Mediterranean Airways": "KJ",
  "Brussels Airlines": "SN",
  "BudgetAir": "1K",
  "Bulgaria Air": "FB",
  "Buquebus Líneas Aéreas": "BQ",
  "Business Aviation": "4P",
  "BusinessAir": "8B",
  "BVI Airways": "XV",
  "CAL Cargo Air Lines": "5C",
  "Calima Aviacion": "XG",
  "Camair-co": "QC",
  "Cambodia Angkor Air": "K6",
  "Canadian National Airways": "CN",
  "Canadian North": "5T",
  "CanXplorer": "C2",
  "CanXpress": "C1",
  "Cape Air": "9K",
  "Cargo Plus Aviation": "8L",
  "Caribbean Airlines": "BW",
  "Carnival Air Lines": "KW",
  "Carpatair": "V3",
  "Caspian Airlines": "RV",
  "Cathay Pacific": "CX",
  "Catovair": "OC",
  "Caucasus Airlines": "NS",
  "Cayman Airways": "KX",
  "CB Airways UK": "1F",
  "CCML Airlines": "CB",
  "Cebu Pacific": "5J",
  "Centralwings": "C0",
  "Chautauqua Airlines": "RP",
  "China Airlines": "CI",
  "China Eastern Airlines": "MU",
  "China Northwest Airlines": "WH",
  "China Southern Airlines": "CZ",
  "China SSS": "9C",
  "China United": "KN",
  "China United Airlines": "HR",
  "Chongqing Airlines": "OQ",
  "Ciel Canadien": "YC",
  "Cimber Air": "QI",
  "Cirrus Airlines": "C9",
  "Citilink Indonesia": "QG",
  "City Airline": "CF",
  "City Airways": "E8",
  "CityJet": "WX",
  "Click": "QA",
  "Coastal Air": "DQ",
  "Colgan Air": "9L",
  "Comair": "MN",
  "CommutAir": "C5",
  "Comores Airlines": "KR",
  "Compagnie Africaine d\\\\'Aviation": "E9",
  "Compass Airlines": "CP",
  "Condor Flugdienst": "DE",
  "Congo Express": "XZ",
  "Consorcio Aviaxsa": "6A",
  "Continental Express": "CO",
  "Continental Micronesia": "CS",
  "Conviasa": "V0",
  "Copa Airlines": "CM",
  "Copenhagen Express": "0X",
  "Corsairfly": "SS",
  "Corse-Mediterranee": "XK",
  "Croatia Airlines": "OU",
  "Cubana de Aviación": "CU",
  "Cyprus Airways": "CY",
  "Cyprus Turkish Airlines": "YK",
  "Czech Airlines": "OK",
  "Daallo Airlines": "D3",
  "Dalavia": "H8",
  "Dana Air": "DA",
  "Danube Wings": "V5",
  "Darwin Airline": "0D",
  "DAT Danish Air Transport": "DX",
  "dba": "DI",
  "Delta Air Lines": "DL",
  "Denim Air": "J7",
  "Dennis Sky": "DH",
  "Dense Airways": "KP",
  "Dense Connection": "KZ",
  "Deutsche Bahn": "2A",
  "Djibouti Airlines": "D8",
  "Dobrolet": "QD",
  "Domenican Airlines": "D1",
  "Dominicana de Aviaci": "DO",
  "Domodedovo Airlines": "E3",
  "Dragonair": "KA",
  "Druk Air": "KB",
  "Eagle Air": "H7",
  "Eagle Atlantic Airlines": "E2",
  "East African": "QU",
  "Eastar Jet": "ZE",
  "Eastern Airways": "T3",
  "Eastland Air": "DK",
  "easyJet": "U2",
  "EasyJet": "DS",
  "Edelweiss Air": "WK",
  "Egyptair": "MS",
  "El Al Israel Airlines": "LY",
  "El-Buraq Air Transport": "UZ",
  "Elysian Airlines": "E4",
  "Emirates": "EK",
  "Empresa Ecuatoriana De Aviacion": "EU",
  "Epic Holiday": "FA",
  "Era Alaska": "7H",
  "Eritrean Airlines": "B8",
  "Estonian Air": "OV",
  "Ethiopian Airlines": "ET",
  "Etihad Airways": "EY",
  "Euro Exec Express": "RZ",
  "Eurocypria Airlines": "UI",
  "Eurofly Service": "GJ",
  "Euroline": "4L",
  "Eurolot": "K2",
  "Europe Jet": "EX",
  "European Air Express": "EA",
  "EuropeSky": "ES",
  "Eurowings": "EW",
  "EVA Air": "BR",
  "Evergreen International Airlines": "EZ",
  "Excel Airways": "JN",
  "Express One International": "EO",
  "ExpressJet": "XE",
  "Far Eastern Air Transport": "EF",
  "Felix Airways": "FU",
  "Finnair": "AY",
  "Finncomm Airlines": "FC",
  "Firefly": "FY",
  "First Air": "7F",
  "First Choice Airways": "DP",
  "Flightline": "B5",
  "Flightlink Tanzania": "Z9",
  "Florida West International Airways": "RF",
  "Fly 6ix": "6I",
  "Fly Brasil": "F1",
  "Fly Colombia": "3F",
  "Fly Dubai": "FZ",
  "Fly Europa": "ER",
  "Fly France": "FF",
  "Fly One": "F5",
  "Fly Romania": "X5",
  "Fly540": "5H",
  "Flybaboo": "F7",
  "Flybe": "BE",
  "Flyglobespan": "B4",
  "FlyHigh Airlines Ireland": "FH",
  "FlyLal": "TE",
  "FlyNordic": "LF",
  "FlyPortugal": "PO",
  "Formosa Airlines": "VY",
  "FOX Linhas Aereas": "FX",
  "Freedom Air": "FP",
  "Frontier Airlines": "F9",
  "Frontier Flying Service": "2F",
  "Fuji Dream Airlines": "JH",
  "Gabon Airlines": "GY",
  "Gadair European Airlines": "GP",
  "Garuda Indonesia": "GA",
  "Gazpromavia": "4G",
  "GB Airways": "GT",
  "Genesis": "GK",
  "Georgian Airways": "A9",
  "Georgian National Airlines": "QB",
  "German International Air Lines": "GM",
  "Germania": "ST",
  "Germanwings": "4U",
  "GermanXL": "GX",
  "Ghana International Airlines": "G0",
  "Global Airlines": "0G",
  "Globus": "GH",
  "GNB Linhas Aereas": "GN",
  "Go Air": "G8",
  "GoJet Airlines": "G7",
  "Golden Air": "DC",
  "Gomelavia": "YD",
  "Great Lakes Airlines": "ZK",
  "Greenfly": "XX",
  "Grupo TACA": "TA",
  "Gryphon Airlines": "6P",
  "Gulf Air Bahrain": "GF",
  "Hageland Aviation Services": "H6",
  "Hainan Airlines": "HU",
  "Haiti Ambassador Airlines": "2T",
  "Halcyonair": "7Z",
  "Hamburg International": "4R",
  "Hankook Air US": "H1",
  "Hankook Airline": "HN",
  "Hapagfly": "HF",
  "Harbour Air": "H3",
  "Hawaiian Airlines": "HA",
  "Hawkair": "BH",
  "Heli France": "8H",
  "Helijet": "JB",
  "Hellas Jet": "T4",
  "Hellenic Imperial Airways": "HT",
  "Hello": "HW",
  "Helvetic Airways": "2L",
  "Hex'Air": "UD",
  "Hi Fly": "5K",
  "Himalayan Airlines": "HC",
  "Hokkaido International Airlines": "HD",
  "Homer Air": "MR",
  "Hong Kong Airlines": "HX",
  "Hong Kong Express Airways": "UO",
  "Horizon Air": "QX",
  "Horizon Airlines": "BN",
  "Huaxia": "G5",
  "I-Fly": "H5",
  "Iberia Airlines": "IB",
  "Iberia Express": "I2",
  "Iberworld": "TY",
  "Ibex Airlines": "FW",
  "Icelandair": "FI",
  "Imair Airlines": "IK",
  "INAVIA Internacional": "Z5",
  "Indian Airlines": "IC",
  "Indigo": "I9",
  "IndiGo Airlines": "6E",
  "Indonesia AirAsia": "QZ",
  "Indonesia Sky": "I5",
  "Indonesian Airlines": "IO",
  "Indya Airline Group": "G1",
  "Insel Air (7I/INC)": "7I",
  "Interair South Africa": "D6",
  "Interjet": "4O",
  "Interlink Airlines": "ID",
  "International AirLink": "I4",
  "International Europe": "9I",
  "Intersky": "3L",
  "Iran Air": "IR",
  "Iran Aseman Airlines": "EP",
  "Iraqi Airways": "IA",
  "Island Air": "WP",
  "Island Airlines": "IS",
  "Island Express Air": "1X",
  "Island Spirit": "IP",
  "Islas Airways": "IF",
  "Islena De Inversiones": "WC",
  "Israir": "6H",
  "Itek Air": "GI",
  "IzAvia": "I8",
  "JAL Express": "JC",
  "JALways": "JO",
  "Japan Air System": "JD",
  "Japan Airlines": "JL",
  "Japan Asia Airways": "EG",
  "Japan Regio": "ZX",
  "Japan Transocean Air": "NU",
  "Jazeera Airways": "J9",
  "Jeju Air": "7C",
  "Jet Airways": "QJ",
  "Jet2.com": "LS",
  "Jet4You": "8J",
  "Jetairfly": "JF",
  "JetBlue Airways": "B6",
  "Jetgo Australia": "JG",
  "Jetstar Airways": "JQ",
  "Jetstar Asia Airways": "3K",
  "Jetstar Pacific": "BL",
  "Jettor Airlines": "NR",
  "Jin Air": "LJ",
  "JobAir": "3B",
  "Joy Air": "JR",
  "Juneyao Airlines": "HO",
  "Jusur airways": "JX",
  "Kam Air": "RQ",
  "Kavminvodyavia": "KV",
  "KD Avia": "KD",
  "Kenmore Air": "M5",
  "Kenya Airways": "KQ",
  "Kharkiv Airlines": "KH",
  "Kingfisher Airlines": "IT",
  "Kish Air": "Y9",
  "KLM Cityhopper": "WA",
  "KLM Royal Dutch Airlines": "KL",
  "Kogalymavia Air Company": "7K",
  "KoralBlue Airlines": "K7",
  "Korean Air": "KE",
  "Korongo Airlines": "ZC",
  "Kostromskie avialinii": "K1",
  "Krasnojarsky Airlines": "7B",
  "KSY": "KY",
  "Kuban Airlines": "GW",
  "Kuwait Airways": "KU",
  "Kuzu Airlines Cargo": "GO",
  "L": "MJ",
  "LACSA": "LR",
  "LAN Airlines": "LA",
  "LAN Argentina": "4M",
  "LAN Express": "LU",
  "LAN Peru": "LP",
  "Lao Airlines": "QV",
  "Lauda Air": "NG",
  "LCM AIRLINES": "LQ",
  "Leeward Islands Air Transport": "LI",
  "Liberty Airways": "LE",
  "Libyan Arab Airlines": "LN",
  "Line Blue": "L8",
  "Linhas A": "LM",
  "Lion Mentari Airlines": "JT",
  "LionXpress": "C4",
  "Locair": "ZQ",
  "LOT Polish Airlines": "LO",
  "LSM Airlines": "PQ",
  "LSM AIRLINES": "YZ",
  "LSM International": "II",
  "LTE International Airways": "XO",
  "LTU Austria": "L3",
  "Luchsh Airlines": "L4",
  "Luftfahrtgesellschaft Walter": "HE",
  "Lufthansa": "LH",
  "Lufthansa CityLine": "CL",
  "Lufttransport": "L5",
  "Lugansk Airlines": "L7",
  "Luxair": "LG",
  "Maastricht Airlines": "W2",
  "Macair Airlines": "CC",
  "Maersk": "DM",
  "Mahan Air": "W5",
  "Malawian Airlines": "3W",
  "Malaysia Airlines": "MH",
  "Maldivian": "Q2",
  "Maldivo Airlines": "ML",
  "Malév": "MA",
  "Malindo Air": "OD",
  "Malmö Aviation": "TF",
  "Malta Air Charter": "R5",
  "Mandala Airlines": "RI",
  "Mandarin Airlines": "AE",
  "Mango": "JE",
  "Martinair": "MP",
  "Marusya Airways": "Y8",
  "Maryland Air": "M1",
  "Marysya Airlines": "M4",
  "MasAir": "M7",
  "MAT Airways": "6F",
  "MAT Macedonian Airlines": "IN",
  "Mauritania Airlines International": "L6",
  "Maxair": "8M",
  "Maya Island Air": "MW",
  "MDLR Airlines": "9H",
  "Med Airways": "7Y",
  "Meridiana": "IG",
  "Merpati Nusantara Airlines": "MZ",
  "Mesa Airlines": "YV",
  "Mesaba Airlines": "XJ",
  "Metro Batavia": "7P",
  "Mexicana de Aviaci": "MX",
  "MexicanaLink": "I6",
  "MHS Aviation GmbH": "M2",
  "MIAT Mongolian Airlines": "OM",
  "Michael Airlines": "DF",
  "Middle East Airlines": "ME",
  "Midway Airlines": "JI",
  "Midwest Airlines": "MY",
  "MNG Airlines": "MB",
  "Moldavian Airlines": "2M",
  "Mongolian International Air Lines": "7M",
  "Montenegro Airlines": "YM",
  "Moskovia Airlines": "3R",
  "Motor Sich": "M9",
  "Myanma Airways": "UB",
  "MyTravel Airways": "VZ",
  "Myway Airlines": "8I",
  "N1": "N1",
  "Nas Air": "XY",
  "Nasair": "UE",
  "National Air Cargo": "N8",
  "National Jet Systems": "NC",
  "Nationwide Airlines": "CE",
  "Nauru Air Corporation": "ON",
  "Nepal Airlines": "RA",
  "New England Airlines": "EJ",
  "NEXT Brasil": "XB",
  "NextJet": "2N",
  "Niki": "HG",
  "Nile Air": "NP",
  "Nok Air": "DD",
  "Nordic Global Airlines": "NJ",
  "Nordica": "EE",
  "NordStar Airlines": "Y7",
  "Norte Lineas Aereas": "N0",
  "Northern Dene Airways": "U7",
  "Northwest Airlines": "NW",
  "Northwestern Air": "J3",
  "Norwegian Air Shuttle": "DY",
  "Norwegian Long Haul AS": "DU",
  "Nouvel Air Tunisie": "BJ",
  "Novair": "1I",
  "Oasis Hong Kong Airlines": "O8",
  "Oceanair": "O6",
  "Oceanic Airlines": "O2",
  "Olympic Airlines": "OA",
  "Oman Air": "WY",
  "Omni Air International": "OY",
  "OneChina": "1C",
  "OneJet": "J1",
  "Onur Air": "8Q",
  "Orbit Airlines Azerbaijan": "O1",
  "Orchid Airlines": "OI",
  "Orenburg Airlines": "R2",
  "Orient Thai Airlines": "OX",
  "Origin Pacific Airways": "QO",
  "Ostfriesische Lufttransport": "OL",
  "Overland Airways": "OJ",
  "Ozjet Airlines": "O7",
  "Pacific Coastal Airline": "8P",
  "Pacific East Asia Cargo Airlines": "Q8",
  "Pacific Wings": "LW",
  "Pakistan International Airlines": "PK",
  "Pal airlines": "5P",
  "PAN Air": "PV",
  "Pan Am World Airways Dominicana": "7Q",
  "PanAm World Airways": "WQ",
  "Papillon Grand Canyon Helicopters": "HI",
  "Paramount Airways": "I7",
  "Parmiss Airlines": "PA",
  "Patriot Airways": "P4",
  "PB Air": "9Q",
  "Peach Aviation": "MM",
  "Pegasus Airlines": "PC",
  "PEGASUS AIRLINES-": "H9",
  "Pelita": "6D",
  "Peninsula Airways": "KS",
  "Peruvian Airlines": "P9",
  "Philippine Airlines": "PR",
  "Piedmont Airlines": "PI",
  "Pinnacle Airlines": "9E",
  "PLUNA": "PU",
  "PMTair": "U4",
  "Polet Airlines": "YQ",
  "Polynesian Airlines": "PH",
  "Porter Airlines": "PD",
  "Portugalia": "NI",
  "Potomac Air": "BK",
  "Precision Air": "PW",
  "Primera Air": "PF",
  "Proflight Commuter Services": "P0",
  "Qantas": "QF",
  "Qatar Airways": "QR",
  "QatXpress": "C3",
  "RACSA": "R6",
  "Rainbow Air": "RN",
  "Rainbow Air Canada": "RY",
  "Rainbow Air Euro": "RU",
  "Rainbow Air Polynesia": "RX",
  "Rainbow Air US": "RM",
  "Real Tonga": "RT",
  "Red Jet Andes": "PT",
  "Red Jet Canada": "QY",
  "Red Jet Mexico": "4X",
  "Red Wings": "WZ",
  "REDjet": "Z7",
  "Régional": "YS",
  "Regional Air Iceland": "9N",
  "Regional Airlines": "FN",
  "Regional Express": "ZL",
  "Regional Paraguaya": "P7",
  "Regionalia Chile": "9J",
  "Regionalia México": "N4",
  "Regionalia Uruguay": "2X",
  "Regionalia Venezuela": "9X",
  "Republic Airlines": "RW",
  "Republic Express Airlines": "RH",
  "REXAIR VIRTUEL": "RR",
  "Rossiya": "R4",
  "Rossiya-Russian Airlines": "FV",
  "Royal Air Cambodge": "VJ",
  "Royal Air Maroc": "AT",
  "Royal Airways": "KG",
  "Royal Brunei Airlines": "BI",
  "Royal Falcon": "RL",
  "Royal Jordanian": "RJ",
  "Rwandair Express": "WB",
  "Ryan International Airlines": "RD",
  "Ryanair": "FR",
  "S7 Airlines": "S7",
  "Safi Airlines": "4Q",
  "Salmon Air": "S6",
  "Salsa d\\\\'Haiti": "SO",
  "Salzburg arrows": "SZ",
  "Sama Airlines": "ZS",
  "Santa Barbara Airlines": "S3",
  "Saratov Aviation Division": "6W",
  "Sat Airlines": "HZ",
  "SATA Air Acores": "SP",
  "SATA International": "S4",
  "SATENA": "9R",
  "Saudi Arabian Airlines": "SV",
  "Scandinavian Airlines System": "SK",
  "Scat Air": "DV",
  "Scoot": "TZ",
  "Seaborne Airlines": "BB",
  "SeaPort Airlines": "K5",
  "Senegal Airlines": "DN",
  "SENIC AIRLINES": "YR",
  "Serbian Airlines": "S1",
  "Servicios de Transportes A": "FS",
  "Severstal Air Company": "D2",
  "SGA Airlines": "5E",
  "Shaheen Air International": "NL",
  "Shandong Airlines": "SC",
  "Shanghai Airlines": "FM",
  "Sharp Airlines": "SH",
  "Shenzhen Airlines": "ZH",
  "Shuttle America": "S5",
  "Sibaviatrans": "5M",
  "Sichuan Airlines": "3U",
  "Siem Reap Airways": "FT",
  "SilkAir": "MI",
  "Silver Airways": "3M",
  "Singapore Airlines": "SQ",
  "Skagway Air Service": "N5",
  "Sky Airline": "H2",
  "Sky Express": "XW",
  "Sky Regional": "RS",
  "Sky Wing Pacific": "C7",
  "SkyBahamas Airlines": "Q7",
  "SkyEurope": "NE",
  "Skyjet Airlines": "UQ",
  "Skymark Airlines": "BC",
  "Skynet Airlines": "SI",
  "Skynet Asia Airways": "6J",
  "Skyservice Airlines": "5G",
  "Skywalk Airlines": "AL",
  "Skyways Express": "JZ",
  "SkyWest": "OO",
  "Skywest Australia": "XR",
  "SkyWork Airlines": "SX",
  "SmartLynx Airlines": "6Y",
  "Snowbird Airlines": "S8",
  "SOCHI AIR": "CQ",
  "SOCHI AIR CHATER": "Q3",
  "SOCHI AIR EXPRESS": "Q4",
  "Solomon Airlines": "IE",
  "South African Airways": "SA",
  "South East Asian Airlines": "DG",
  "Southern Winds Airlines": "A4",
  "Southwest Airlines": "WN",
  "Spanair": "JK",
  "Spicejet": "SG",
  "Spike Airlines": "S0",
  "Spirit Airlines": "NK",
  "Spirit of Manila Airlines": "SM",
  "Spring Airlines": "9S",
  "Spring Airlines Japan": "IJ",
  "SriLankan Airlines": "UL",
  "Sriwijaya Air": "SJ",
  "Star Flyer": "7G",
  "Star Peru": "2I",
  "Star1 Airlines": "V9",
  "Starbow Airlines": "S9",
  "Starline.kz": "DZ",
  "Sterling Airlines": "NB",
  "STP Airways": "8F",
  "Strategic Airlines": "VC",
  "Sudan Airways": "SD",
  "Sun Country Airlines": "SY",
  "Sun D'Or": "7L",
  "SunExpress": "XQ",
  "Sunwing": "WG",
  "Surinam Airways": "PY",
  "Svyaz Rossiya": "7R",
  "Swe Fly": "WV",
  "Swiss International Air Lines": "LX",
  "Swissair": "SR",
  "Syrian Arab Airlines": "RB",
  "T.J. Air": "TJ",
  "TAAG Angola Airlines": "DT",
  "TACA Peru": "T0",
  "TACV": "VR",
  "Tajik Air": "7J",
  "TAM Brazilian Airlines": "JJ",
  "TAM Mercosur": "PZ",
  "TAME": "EQ",
  "TAMPA": "QT",
  "TAP Portugal": "TP",
  "Tarom": "RO",
  "Tatarstan Airlines": "U9",
  "Texas Wings": "TQ",
  "Thai Air Cargo": "T2",
  "Thai AirAsia": "FD",
  "Thai Airways International": "TG",
  "Thai Lion Air": "SL",
  "Thai Smile Airways": "WE",
  "Thomas Cook Airlines": "MT",
  "Thomsonfly": "BY",
  "Tiara Air": "3P",
  "Tiger Airways": "TR",
  "Tiger Airways Australia": "TT",
  "Tomp Airlines": "ZT",
  "Trans Pas Air": "T6",
  "Trans States Airlines": "AX",
  "Transaero Airlines": "UN",
  "TransAsia Airways": "GE",
  "Transavia France": "TO",
  "Transavia Holland": "HV",
  "TransBrasil Airlines": "TH",
  "TransHolding": "TI",
  "TransHolding System": "YO",
  "TransNusa Air": "M8",
  "TransRussiaAirlines": "1E",
  "Transwest Air": "9T",
  "TrasBrasil": "TB",
  "Travel Service": "QS",
  "TRIP Linhas A": "8R",
  "Tropic Air": "PM",
  "TUIfly": "X3",
  "TUIfly Nordic": "6B",
  "Tuninter": "UG",
  "Tunisair": "TU",
  "Turan Air": "3T",
  "Turkish Airlines": "TK",
  "Turkmenistan Airlines": "T5",
  "Tway Airlines": "TW",
  "Twin Jet": "T7",
  "Tyrolean Airways": "VO",
  "Ukraine International Airlines": "PS",
  "UM Airlines": "UF",
  "Uni Air": "B7",
  "United Airlines": "UA",
  "United Airways": "4H",
  "Ural Airlines": "U6",
  "US Airways": "US",
  "US Helicopter Corporation": "UH",
  "Usa Sky Cargo": "E1",
  "USA3000 Airlines": "U5",
  "UTair Aviation": "UT",
  "UTair-Express": "UR",
  "UVT Aero": "UW",
  "Uzbekistan Airways": "HY",
  "V Air": "ZV",
  "Valuair": "VF",
  "Varig Log": "LC",
  "VASP": "VP",
  "Via Conectia Airlines": "6V",
  "VIA Líneas Aéreas": "V1",
  "VickJet": "KT",
  "Vietnam Airlines": "VN",
  "Viking Hellas": "VQ",
  "VIM Airlines": "NN",
  "VIP Ecuador": "V6",
  "Virgin America": "VX",
  "Virgin Atlantic Airways": "VS",
  "Virgin Australia": "VA",
  "Virgin Express": "TV",
  "Virgin Nigeria Airways": "VK",
  "Virgin Pacific": "VH",
  "Virginwings": "YY",
  "Vision Airlines": "V2",
  "Viva Macau": "ZG",
  "VivaColombia": "5Z",
  "Vladivostok Air": "XF",
  "VLM Airlines": "VG",
  "Voestar": "8K",
  "Volare Airlines": "VE",
  "Volaris": "Y4",
  "Volga-Dnepr Airlines": "VI",
  "VOLOTEA Airways": "V7",
  "Volotea Costa Rica": "9V",
  "VRG Linhas Aereas": "RG",
  "Vuela Cuba": "6C",
  "Vuola Italia": "4S",
  "Wayraper": "7W",
  "WebJet Linhas A": "WJ",
  "Welcome Air": "2W",
  "West Air China": "PN",
  "West Coast Air": "8O",
  "WestJet": "WS",
  "WestJet Encore": "WR",
  "Widerøe": "WF",
  "Wind Jet": "IV",
  "Windward Islands Airways": "WM",
  "Wings Air": "IW",
  "Wizz Air": "W6",
  "Wizz Air Hungary": "8Z",
  "Wizz Air Ukraine": "WU",
  "World Airways": "WO",
  "World Experience Airline": "W1",
  "World Scale Airlines": "W3",
  "XAIR USA": "XA",
  "Xiamen Airlines": "MF",
  "XL Airways France": "SE",
  "Xpressair": "XN",
  "XPTO": "XP",
  "Yamal Airlines": "YL",
  "Yangon Airways": "HK",
  "Yangon Airways Ltd.": "YH",
  "Yellowstone Club Private Shuttle": "Y1",
  "Yellowtail": "YE",
  "Yemenia": "IY",
  "Yeti Airways": "YT",
  "Yunnan Airlines": "3Q",
  "ZABAIKAL AIRLINES": "Z6",
  "Zabaykalskii Airlines": "ZP",
  "Zambezi Airlines": "ZJ",
  "Zambia Skyways": "K8",
  "Zenith International Airline": "ZN",
  "Zest Air": "Z2",
  "Zoom Airlines": "Z4",
  "Zz": "ZZ"
};

// A handful of fixes on top of the raw OpenFlights snapshot (~2014) for
// major carriers this app's routes actually use: airlines that rebranded
// or merged since then, and one stale code collision with a defunct
// airline that had reused the same IATA code.
const NAME_OVERRIDES = {
  'Fly Dubai': 'Flydubai',
  'KLM Royal Dutch Airlines': 'KLM',
  'Swiss International Air Lines': 'Swiss',
  'Scandinavian Airlines System': 'SAS',
  'Iberia Airlines': 'Iberia',
  'Egyptair': 'EgyptAir',
  'Gulf Air Bahrain': 'Gulf Air',
  'Air India Limited': 'Air India',
  'All Nippon Airways': 'ANA',
  'Thai Airways International': 'Thai Airways',
  'LAN Airlines': 'LATAM', // merged into LATAM Airlines Group in 2016
  'Avianca - Aerovias Nacionales de Colombia': 'Avianca',
  'IndiGo Airlines': 'IndiGo',
  'Spicejet': 'SpiceJet',
  'Nas Air': 'flynas', // rebranded from Nas Air
  'Formosa Airlines': 'Vueling', // stale code collision in the source data
  'TAP Portugal': 'TAP Air Portugal',
  'Norwegian Air Shuttle': 'Norwegian',
  'Thomsonfly': 'TUI Airways', // rebranded from Thomsonfly/Thomson Airways
  'China Eastern Airlines': 'China Eastern',
  'China Southern Airlines': 'China Southern',
};
for (const [oldName, newName] of Object.entries(NAME_OVERRIDES)) {
  if (oldName in AIRLINE_CODES) {
    AIRLINE_CODES[newName] = AIRLINE_CODES[oldName];
    delete AIRLINE_CODES[oldName];
  }
}
AIRLINE_CODES['flyadeal'] = 'F3'; // founded 2017, after the source snapshot

export const AIRLINES = Object.keys(AIRLINE_CODES).sort();

// IATA code -> airline name, derived once for flight-number parsing.
export const CODE_TO_AIRLINE = Object.fromEntries(
  Object.entries(AIRLINE_CODES).map(([name, code]) => [code, name])
);
